import { Box, Grid, styled, Typography } from '@mui/material';

import theme, { colors } from '../../../../theme';

export const Title = styled(Typography)`
    font: 600 14px 'Inter';
    color: ${colors.white90};
`;

export const Content = styled(Typography)`
    font: 13px/23px 'Inter';
    color: ${colors.white50};
    white-space: pre-wrap;
    // max-height: 50vh;
    // overflow-y: scroll;
`;

export const RatingTitle = styled(Typography)`
    font: 600 14px 'Inter';
    color: ${colors.white90};
    white-space: pre-wrap;
    margin-bottom: 16px;
    '*::-webkit-scrollbar': {
        width: '0.4em'
      },
      '*::-webkit-scrollbar-track': {
        '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
      },
      '*::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,.1)',
        outline: '1px solid slategrey'
      };
`;

export const DescriptionTitle = styled(Typography)`
    font: 15px 'Inter';
    color: ${colors.white50};
    margin-bottom: 16px;
`;

export const ReadButton = styled(Box)`
    font: 13px/23px 'Inter';
    color: ${colors.orangeyYellow80};
    margin-left: 7px;
    text-decoration: underline;
    cursor: pointer;
`;

export const Container = styled(Box)`
    background-color: ${colors.tealishBlue};
    border-radius: 4px;
    padding: 24px;  
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow-y: scroll;
`;

export const AttachmentsContainer = styled(Box)({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1)
});

export const AttachmentsHeader = styled(Typography)({
    fontSize: '14px',
    color: colors.white50,
    marginBottom: theme.spacing(1)
});

export const AttachmentsGrid = styled(Grid)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '8px',
    maxHeight: '150px',
    overflowY: 'auto'
});

export const AttachmentItem = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    padding: '6px 12px',
    backgroundColor: colors.codGray,
    borderRadius: '12px',
    fontSize: '12px',
    gap: '6px',
    color: colors.mainGold,
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: '#3D3F4A'
    }
});
